<template>
	<el-main class="main-container markdown-body">
		<div :class="isConversations.title || messages.length ? '' : 'main-container-chat-center'" class="main-container-chat">
			<div ref="messageContainer" :class="{ 'chat-content': messages.length > 0 || isConversations.title }">
				<div :class="{ 'chat-content-title': isConversations.title }" :style="{ width: 'calc(100% - 300px)' }">
					{{ isConversations.title }}
				</div>
				<div v-if="loadingHistory && messages.length === 0" class="chat-content-loading">
					<i class="el-icon-loading"></i>
					<span>加载中...</span>
				</div>
				<div v-if="messages.length > 0" class="chat-content-content-title">
					<ChatMessage
						v-for="(message, index) in messages"
						:key="index"
						:message="message"
						:is-last="index === messages.length - 1"
						:uis-login="uisLogin"
						:uinfo="uinfo"
						@feedback="handleFeedback"
						@toggle-content="toggleAdditionalContent"
						@regenerate="handleRegenerate"
					/>
				</div>
			</div>
			<ChatInput
				v-model="keywork"
				:is-conversations="isConversations"
				:messages="messages"
				:selected-book-list="selectedBookList"
				:chat-type="chatType"
				:uis-login="uisLogin"
				:uis-vip="uisVIP"
				:ai-count="aiCount"
				:show-auto-badge="showAutoBadge"
				:show-rag-badge="showRagBadge"
				:show-agent-badge="showAgentBadge"
				:is-last-message-typing="isLastMessageTyping"
				:should-disable-submit="shouldDisableSubmit"
				@submit="onSubmit"
				@pause="handlePause"
				@clear="handleClearConversation"
				@change-chat-type="changeChatType"
				@remove-book="removeBookList"
								@clear-books="clearAllBooks"
				@select-book="handleSelectBook"
				@login="handleLogin"
				:pending-images="selectedImages"
				@update:pending-images="val => (selectedImages = val)"
			/>
		</div>

		<AnchorNav :conversation-groups="conversationGroups" :active-anchor-index="activeAnchorIndex" @scroll-to="scrollToConversation" />

		<!--反馈弹窗-->
		<FeedBack :messagesId="messagesId" :reason="reason" :visible.sync="feedbackVisible" @cancel="feedbackVisible = false" @submitFeedback="submitFeedback" />
		<!-- 选择书单 -->
		<DialogBookJson ref="DialogBookJson" @confirm="handleConfirmBookJson" @close="dialogBookJsonVisible = false" @cancel="handleCancelBookJson" />

		<!-- 抽屉--深度思考过程 -->
	</el-main>
</template>

<script>
	import {
		getFilesDocmentFindBookJsonList,
		getAiCount,
		postStopTask,
		getConversationsList,
		createNewConversations,
		renameConversation,
		deleteConversation,
		clearConversation,
		feedback,
		listMsg,
		kbChat,
		kbChatAuto
	} from '@/api/ai/ai.js';
	import { mapGetters, mapActions } from 'vuex';
	
	import bus from '@/bus';
	import FeedBack from './FeedBack.vue';
	import ChatMessage from './ChatMessage.vue';
	import ChatInput from './ChatInput.vue';
	import AnchorNav from './AnchorNav.vue';
	import merge from 'webpack-merge';
	import TMessage from '@/utils/TMessage';
	import EReg from '@/utils/EReg';
	import TLoading from '@/utils/TLoading';
	import TMessageBox from '@/utils/TMessageBox';
	import { getFilesDocmentClauseInfo, getReadCheck } from '@/api/standards/doc';
	import { getStandardDet } from '@/api/standards/det';
	import { getTimestamp, setTimestamp, removeTimestamp } from '@/utils/Cookies';
	import DialogBookJson from './DialogBookJson.vue';

	export default {
		components: {
			ChatMessage,
			ChatInput,
			AnchorNav,
			FeedBack,
			DialogBookJson
		},
		props: {
			asideList: {
				type: Object,
				default: () => {}
			},
			chatItem: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				// thinkProcessStr: '',
				isNewConversations: true, // 是否是新对话
				isConversations: {}, // 当前对话信息
				messages: [], // 消息列表
				chatType: 'auto', // 对话类型
				keywork: '', // 关键词

				feedbackVisible: false, // 反馈弹窗
				isAutoScroll: true, // 控制是否自动滚动,

				messagesId: '', // 消息id
				reason: '', // 反馈理由

				showStatusText: '', // 显示状态文本 深度思考模式下
				eventSource: null, // sse链接

				shouldDisableSubmit: false,
				
				// AI计数器
				aiCount: {
					auto: 0,
					agent: 0,
					rag: 0,
					agentPost: 0,
					autoPost: 0,
					ragPost: 0
				},

				// 选中的书单列表
				selectedBookList: [],

				// 待发送图片列表（url: 预览, base64: 发送）
				selectedImages: [],

				//对话中的书单列表
				historyBookList: [],

				isRepeatClick: false, // 重复点击

				// 锚点导航
				activeAnchorIndex: -1,
			
				// 历史对话加载状态
				loadingHistory: false
			};
		},
		mounted() {
			// 使用事件委托为 ai-link 添加点击事件
			document.addEventListener('click', event => {
				// console.log('event', event.target);
				if (event.target.classList.contains('ai-link')) {
					event.preventDefault(); // 如果需要阻止默认跳转
					const searchParams = new URLSearchParams(event.target.search);
					const query = searchParams.get('wd');
					this.handleAiLinkClick(query);
				}
			});
			this.$nextTick(() => {
				this.scrollToBottom();
				// console.log('mounted', this.$refs.messageContainer);
				this.$refs.messageContainer.addEventListener('scroll', this.handleScroll);
			});
			bus.$on('openNewChat', () => {
				this.openNewChat();
			});
			bus.$on('openHistoryChat', val => {
				this.openHistoryChat(val);
			});
		},
		created() {
			this.getAiCount();

			// 从首页携带问题参数跳转，自动填充输入框并发送
			const question = this.$route.query.question;
			if (question) {
				this.keywork = question;
				// 清除 URL 参数，避免刷新时重复发送
				this.$router.replace({ query: { ...this.$route.query, question: undefined } });
				// 等待初始化（aiCount获取）完成再自动提交
				this.$nextTick(() => {
					setTimeout(() => {
						if (this.keywork.trim()) {
							this.onSubmit();
						}
					}, 500);
				});
			}
		},
		watch: {
			uisLogin: function (newVal, oldVal) {
				if (newVal && !oldVal) {
					this.getAiCount();
				}
			},
			sError: function (newVal, oldVal) {
				if (newVal) {
					// console.log('错误信息-500');
					if (this.messages.length) {
						//最后1条的error = true;
						if (!this.isConversations.title) {
							this.isConversations.title = '新对话';
						}
						const lastMessageIndex = this.messages.length - 1;
						this.messages[lastMessageIndex].error = true;
						this.messages[lastMessageIndex].isTyping = false;
						this.messages[lastMessageIndex].errorStr = '发生错误，请稍后再试';
						this.messages[lastMessageIndex].isThinking = false;
						this.messages[lastMessageIndex].hasThought = false; // 错误情况下标记为未思考
					}
				}
			}
		},
		computed: {
			...mapGetters('User', ['uinfo', 'utoken', 'uisLogin', 'uisVIP']),
			...mapGetters('Settings', ['sError']),

			// 判断最后一条消息是否正在生成，显示 提交 or 暂停
			isLastMessageTyping() {
				// console.log('isLastMessageTyping', this.messages.length, this.messages);
				if (this.messages.length === 0) {
					return false;
				} else {
					const lastMessage = this.messages[this.messages.length - 1];
					return lastMessage.role === 'assistant' && lastMessage.isTyping && !lastMessage.isPause;
				}
			},

			// 快速回答badge显示逻辑
			showRagBadge() {
				// 只有在鼠标悬停时才考虑显示badge
				// if (!this.isHoveringRag) {
				// 	return false;
				// }
				// 未登录时显示badge
				if (!this.uisLogin) {
					return true;
				}
				// 已登录非VIP时隐藏badge
				if (!this.uisVIP) {
					return false;
				}
				// 已登录VIP时隐藏badge
				return false;
			},

			// 深度思考badge显示逻辑
			showAgentBadge() {
				// 未登录时显示badge（深度思考不可用）
				if (!this.uisLogin) {
					return true;
				}
				// 已登录非VIP时隐藏badge
				if (!this.uisVIP) {
					return false;
				}
				// 已登录VIP时隐藏badge
				return false;
			},

			// 自动模式badge显示逻辑
			showAutoBadge() {
				// 未登录时显示badge（自动模式不可用）
				if (!this.uisLogin) {
					return true;
				}else {
					return false;
				}
			},

			// 书单模式badge显示逻辑
			showBookBadge() {
				// 未登录时显示badge（书单模式不可用）
				return !this.uisLogin;
			},

			// 对话分组（锚点导航用）
			conversationGroups() {
				const groups = [];
				for (let i = 0; i < this.messages.length; i += 2) {
					const userMsg = this.messages[i];
					if (userMsg && userMsg.role === 'user') {
						groups.push({
							userIndex: i,
							question: userMsg.content || ''
						});
					}
				}
				return groups;
			}
		},
		methods: {
			handleSelectBook() {
				this.$refs.DialogBookJson.open();
			},

			handleConfirmBookJson(bookList) {
				this.selectedBookList = bookList;
				this.chatType = 'book';
				// console.log('选择书单', this.selectedBookList);
			},
			handleCancelBookJson() {
				if (this.selectedBookList && this.selectedBookList.length > 0) {
					this.chatType = 'book';
				} else {
					this.chatType = 'auto';
				}
			},
			handleVip() {
				const targetRoute = this.$router.resolve({
					path: '/VIPList'
				});
				window.open(targetRoute.href, '_blank');
			},
			...mapActions('Settings', ['setLoginShow']),
			handleLogin() {
				this.setLoginShow(true);
				// const targetRoute = this.$router.resolve({
				// 	path: '/login'
				// });
				// window.open(targetRoute.href, '_blank');
			},

			// 移除选中的书单
			removeBookList(item) {
				const index = this.selectedBookList.findIndex(book => book.value === item.value);
				if (index !== -1) {
					this.selectedBookList.splice(index, 1);
				}
				// 书单全部移除后，切换回快速回答模式
				if (this.selectedBookList.length === 0) {
					this.chatType = 'auto';
				}
				// console.log('移除之后', this.selectedBookList);
			},

			clearAllBooks() {
				this.selectedBookList = [];
			},

			handleRegenerate() {
				//keywork 是最后的问题
				const lastMessage = this.messages[this.messages.length - 2];
				this.keywork = lastMessage.content;
				this.historyBookList = lastMessage.apiBookList;
				// 恢复问题中上传的图片
				this.selectedImages = lastMessage.imageList ? JSON.parse(JSON.stringify(lastMessage.imageList)) : [];
				//去掉最后的2条消息
				this.messages.splice(this.messages.length - 2, 2);
				this.onSubmit();
			},

			async getAiCount() {
				let res = await getAiCount();
				if (res.code == 200) {
					this.aiCount = res.data;
				}
			},

			handleAiLinkClick(query) {
				if (!this.uisLogin) {
					TMessage.warning('请先登录，才能查看文件详情');
					return;
				}

				// 防止重复点击 - 检查是否正在处理中
				if (this.isRepeatClick) {
					TMessage.warning('正在处理中，请稍候...');
					return;
				}

				// 处理点击事件的逻辑
				// console.log('AI链接被点击，查询参数:', query);

				// 设置重复点击标志
				this.isRepeatClick = true;

				// 设置自动重置机制，防止网络问题导致按钮永久禁用
				const resetTimer = setTimeout(() => {
					this.isRepeatClick = false;
				}, 10000); // 10秒后自动重置

				// 显示加载状态
				// const loading = this.$loading({
				// 	lock: true,
				// 	text: '正在获取文件信息...',
				// 	spinner: 'el-icon-loading',
				// 	background: 'rgba(255, 0, 0, 0.7)'
				// });

				getFilesDocmentClauseInfo(query)
					.then(res => {
						if (res.code == 200) {
							if (res.data) {
								let docInfo = res.data;
								//跳转PDF文档
								this.getFilesDocmentClauseInfoToPdf(docInfo.docmentId, docInfo.pageId, docInfo.position, query);
							} else {
								TMessage.warning(res.msg || '未找到文件！');
							}
						} else {
							TMessage.error(res.msg || '获取文件信息失败');
						}
					})
					.catch(error => {
						console.error('获取文件信息失败:', error);
						TMessage.error('获取文件信息失败，请稍后重试');
					})
					.finally(() => {
						// 清除自动重置定时器
						clearTimeout(resetTimer);
						// 重置重复点击标志
						this.isRepeatClick = false;
						// 关闭加载状态
						// loading.close();
					});
			},

			// 切换附加内容显示/隐藏
			toggleAdditionalContent(messageId) {
				// console.log('点击折叠按钮，messageId:', messageId);
				const message = this.messages.find(msg => msg.id === messageId && msg.role === 'assistant');
				// console.log('找到的消息:', message);
				// console.log('当前折叠状态:', message?.showAdditionalContent);
				if (message) {
					// 使用Vue.set确保响应式更新
					const newState = !message.showAdditionalContent;
					this.$set(message, 'showAdditionalContent', newState);
					// console.log('更新后的折叠状态:', message.showAdditionalContent);
					// console.log('所有消息:', this.messages);
				}
			},

			//获取文档详情
			async getFilesDocmentClauseInfoToPdf(docmentId, pageId, position, clauseId) {
				try {
					const res = await getStandardDet(docmentId);
					if (res.code == 200) {
						// console.log('res跳转信息', res);
						let standardInfo = res.data;

						//如果有结构化优先跳转 结构化，否则pdf

						const res1 = await getReadCheck(docmentId);
						if (res1.code == 200) {
							const { pdfRead, jsonRead } = res1.data;
							if (jsonRead) {
								const targetRoute = this.$router.resolve({
									path: '/StandardsDoc',
									query: { id: standardInfo.id, code: standardInfo.standardCode, title: standardInfo.standardName, docId: standardInfo.id, clauseId }
								});
								window.open(targetRoute.href, '_blank');
							} else {
								if (standardInfo.defaultPdf) {
									if (pdfRead) {
										const targetRoute = this.$router.resolve({
											path: '/StandardsPdf',
											query: { id: standardInfo.id, code: standardInfo.standardCode, title: standardInfo.standardName, fileName: standardInfo.defaultPdf, pageId }
										});
										window.open(targetRoute.href, '_blank');
									} else {
										// TMessage.warning('请您购买后阅读文件！');
										const targetRoute = this.$router.resolve({
											path: '/StandardsDet',
											query: { id: standardInfo.id}
										});
										window.open(targetRoute.href, '_blank');
									}
								} else {
									const targetRoute = this.$router.resolve({
										path: '/StandardsDet',
										query: { id: standardInfo.id }
									});
									window.open(targetRoute.href, '_blank');
								}
							}
						}

						// if (standardInfo.defaultPdf) {
						// 	const res1 = await getReadCheck(docmentId);
						// 	if (res1.code == 200) {
						// 		let pdfRead = res1.data.pdfRead;
						// 		if (pdfRead) {
						// 			const targetRoute = this.$router.resolve({
						// 				path: '/index/StandardsPdf',
						// 				query: { id: standardInfo.id, code: standardInfo.standardCode, title: standardInfo.standardName, fileName: standardInfo.defaultPdf, pageId }
						// 			});
						// 			window.open(targetRoute.href, '_blank');
						// 		} else {
						// 			TMessage.warning('请您购买后阅读文件！');
						// 		}
						// 	} else {
						// 		TMessage.error(res1.msg || '检查阅读权限失败');
						// 	}
						// } else {
						// 	// 跳转到详情页
						// 	const targetRoute = this.$router.resolve({
						// 		path: '/index/StandardsDet',
						// 		query: { id: standardInfo.id, standardName: standardInfo.standardName }
						// 	});
						// 	window.open(targetRoute.href, '_blank');
						// }
					} else {
						TMessage.error(res.msg || '获取标准详情失败');
					}
				} catch (error) {
					console.error('获取文档详情失败:', error);
					TMessage.error('获取文档详情失败，请稍后重试');
				}
			},

			handleScroll(event) {
				const container = event.target;
				// 判断是否接近底部（阈值可调整）
				const threshold = 50;
				const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < threshold;
				// 如果接近底部，则允许自动滚动
				this.isAutoScroll = isNearBottom;
				this.updateActiveAnchor();
			},

			//反馈信息
			handleFeedback(id, type, count, toolStatus) {
				if (!this.uisLogin) {
					this.$message.warning('请先登录，体验更多功能');
					return;
				}
				// 找到对应的消息
				const messageIndex = this.messages.findIndex(msg => msg.id === id && msg.role === 'assistant');
				if (messageIndex === -1) return;
				const message = this.messages[messageIndex];
				switch (type) {
					case 0: // 不喜欢
						// message.toolStatus.feedback = true;
						if (message.toolStatus.disliked) {
							message.toolStatus.disliked = !message.toolStatus.disliked;
							this.postFeedback(id, -1);
						} else {
							this.messagesId = id;
							// this.reason = message.toolStatus.reason;
							this.feedbackVisible = true;
						}
						break;
					case 10: // 喜欢
						message.toolStatus.liked = !message.toolStatus.liked;
						message.toolStatus.disliked = false; // 如果喜欢，则取消不喜欢
						if (message.toolStatus.liked) {
							this.postFeedback(id, 10);
						} else {
							this.postFeedback(id, -1);
						}
						break;
				}
			},

			submitFeedback(form) {
				// console.log('submitFeedback', form);
				const messageIndex = this.messages.findIndex(msg => msg.id === form.message_id && msg.role === 'assistant');
				if (messageIndex === -1) return;
				const message = this.messages[messageIndex];
				message.toolStatus.disliked = !message.toolStatus.disliked;
				message.toolStatus.liked = false; // 如果不喜欢，则取消喜欢
				// message.toolStatus.reason = form.reason;
			},

			//提交反馈信息
			postFeedback(id, type) {
				let params = {
					message_id: id,
					score: type,
					reason: ''
				};
				feedback(params).then(res => {
					TMessage.success('反馈提交成功');
					// this.getListMsg(this.$route.query.id);
				});
			},

			//开启新对话
			openNewChat() {
				if (this.eventSource) {
					this.eventSource.close();
				}
				this.shouldDisableSubmit = false;
				this.isNewConversations = true;
				this.chatType = 'auto';
				this.keywork = '';
				this.messages = [];
				this.selectedBookList = []; // 清空选中的书单
				this.selectedImages = []; // 清空待发送图片
				this.isConversations = {};
				this.$router.replace({
					query: merge(this.$route.query, { id: '', title: '' })
				});
			},

			//打开历史对话
			openHistoryChat(val) {
				if (this.eventSource) {
					this.eventSource.close();
				}
				const { id, title } = val;
				this.isConversations = val;
				this.shouldDisableSubmit = false;
				this.isNewConversations = false;
				this.chatType = 'auto';
				this.messages = [];
				this.selectedBookList = []; // 清空选中的书单
				this.selectedImages = []; // 清空待发送图片
				this.keywork = ''; // 清空输入框
				this.loadingHistory = true;
				this.$router
					.replace({
						query: merge(this.$route.query, { id, title })
					})
					.then(() => {
						// 路由更新完成后获取消息
						this.getListMsg(id);
					});
			},
			
			//获取历史对话
			getListMsg(val) {
				listMsg(val)
					.then(res => {
						let data = res.data;
						// console.log(' res.data', data);
						this.messages = [];
						if (data.length) {
							for (let i in data) {
								let dataItem = data[i];
								let meta_data = dataItem.meta_data;
								let thinking_process = '';
								//先判断 meta_data 不等于 {}
								if (meta_data) {
									if (JSON.stringify(meta_data) !== '{}') {
										if (meta_data.thinking_process.length) {
											//遍历 加等号
											for (let j in meta_data.thinking_process) {
												let item = meta_data.thinking_process[j];
												thinking_process += `${item.content}\n`;
											}
											// EReg 处理思考过程
											thinking_process = EReg.aiFormatContentWithLinks(thinking_process);
											thinking_process = EReg.removeNewlinesInLatexFormulas(thinking_process);
											thinking_process = EReg.smartRenderLatexFormulas(thinking_process);
											thinking_process = EReg.tableToNewLine(thinking_process);
										}
									}
								}

								let messageQuery = EReg.removeNewlinesInLatexFormulas(dataItem.query);
								messageQuery = EReg.smartRenderLatexFormulas(messageQuery);

								let response = EReg.aiFormatContentWithLinks(dataItem.response);
								response = EReg.removeNewlinesInLatexFormulas(response);

								response = EReg.smartRenderLatexFormulas(response);

								//判断是否包含图片（表格内图片走专用行内渲染，避免块级占位符破坏表格）
								response = EReg.formatImageWithTableCheck(response);

								response = EReg.tableToNewLine(response);

								// 分割内容：以 "### 最终解答" 为分隔符，保留分割串在mainContent中
								let mainContent = response;
								let additionalContent = '';
								const resArr = ['### 最终解答：', '### 最终解答', '### 专业解答：', '### 专业解答'];
								//包含了resArr中的任意一个，就用resArr中的这个去分割
								if (response && resArr.some(item => response.includes(item))) {
									const parts = response.split(resArr.find(item => response.includes(item)));
									// parts[0] 是思考过程，parts[1] 是最终答案（包含 "### 最终解答" 这几个字）
									additionalContent = parts[0] || '';
									mainContent = parts[1] || '';
								}

								//dataItem.image_base64_list 如果是 null 或者 undefined，需要转成 []
								if (dataItem.image_base64_list === null || dataItem.image_base64_list === undefined) {
									dataItem.image_base64_list = [];
								}

								this.messages.push({
									role: 'user',
									id: dataItem.id,
									content: messageQuery,
									isTyping: false,
									copied: false,
									isPause: false,
									historyBookList: dataItem.book_list || [],
									imageList: dataItem.image_base64_list.map(url => ({ url }))
								});
								this.messages.push({
									role: 'assistant',
									id: dataItem.id,
									content: response,
									mainContent: mainContent,
									additionalContent: additionalContent,
									isTyping: false,
									copied: false,
									isPause: false,
									isThinking: false,
									hasThought: true,
									// 添加工具栏状态
									toolStatus: {
										copied: false,
										liked: dataItem.score == 10 ? true : false,
										disliked: dataItem.score == 0 ? true : false,
										feedback: dataItem.reason ? true : false,
										reason: dataItem.reason ? dataItem.reason : ''
									},
									// 默认显示附加内容
									showAdditionalContent: false,
									// 思考过程
									thinking_process: thinking_process,
									createTime: dataItem.create_time ? dataItem.create_time.substring(0, 16).replace('T', ' ') : ''
								});
							}
						}
						// console.log('this.messages', this.messages);
						this.loadingHistory = false;
						this.$nextTick(() => {
							this.scrollToBottom();
						});
					})
					.catch(error => {
						this.loadingHistory = false;
					});
			},

			//提交
			onSubmit() {
				//首先判断上一个消息是否完成
				if (this.messages.length > 0 && this.messages[this.messages.length - 1].isTyping) {
					return;
				}
				// 正常提交逻辑
				if (!this.keywork.trim() && this.selectedImages.length === 0) {
					this.$message.warning('请输入内容');
					return;
				}
				
				// 书单模式需要登录
				if (this.chatType === 'book' && !this.uisLogin) {
					this.$message.warning('请先登录，体验更多功能');
					return;
				}
				// 书单模式必须选择书单
				if (this.chatType === 'book' && this.selectedBookList.length === 0) {
					this.$message.warning('书单模式下请先选择书单');
					return;
				}
				// 未登录状态：检查对应模式次数
				if (!this.uisLogin) {
					if (this.chatType === 'auto' && this.aiCount.autoPost === 0) {
						this.$message.warning('没有继续提问机会，请先登录');
						return;
					}
					if (this.chatType === 'rag' && this.aiCount.ragPost === 0) {
						this.$message.warning('没有继续提问机会，请先登录');
						return;
					}
					if (this.chatType === 'agent' && this.aiCount.agentPost === 0) {
						this.$message.warning('没有继续提问机会，请先登录');
						return;
					}
				} else {
					// 已登录状态
					// 快速回答：未登录时检查次数
					if ((this.chatType === 'rag' || this.chatType === 'book') && this.aiCount.ragPost === 0) {
						this.$message.warning('没有继续提问机会了，请升级账号');
						return;
					}
				}
				this.shouldDisableSubmit = true;

				console.log('this.selectedImages', this.selectedImages);
				// return

				// 添加用户消息到 messages
				const userMessage = {
					role: 'user',
					content: this.keywork.trim(),
					historyBookList: JSON.parse(JSON.stringify(this.selectedBookList)),
					isTyping: false,
					copied: false,
					isPause: false,
					imageList: JSON.parse(JSON.stringify(this.selectedImages))
				};
				// 添加 assistant 的空消息占位符
				const assistantMessage = {
					role: 'assistant',
					content: '',
					mainContent: '', // 主要内容（分割后的前半部分）
					additionalContent: '', // 附加内容（分割后的后半部分）
					showStatusText: '', // 当前消息的状态文本
					isTyping: true,
					copied: false,
					isPause: false,
					isThinking: true,
					hasThought: false,
					isError: false,
					// 添加工具栏状态
					toolStatus: {
						copied: false,
						liked: false,
						disliked: false,
						feedback: false,
						reason: ''
					},
					showAdditionalContent: false,
					thinking_process: '',
					createTime: ''
				};

				this.messages.push(userMessage);
				this.messages.push(assistantMessage);

				this.keywork = '';
				this.selectedImages = [];

				if (this.isNewConversations) {
					createNewConversations(this.chatType, String(this.uinfo.id)).then(res => {
						if (res.code == 200) {
							this.isConversations = res.data;

							this.$router.replace({
								query: merge(this.$route.query, { id: this.isConversations.id, title: this.isConversations.title  })
							});

							if (this.uisLogin) {
								this.asideList.today.unshift(res.data);
								this.$emit('updateAsideList', this.asideList.today);
							}

							this.connectSSEWithParams(userMessage.content, userMessage.imageList);
							// this.selectedImages = []; // 清空待发送图片
							this.isNewConversations = false;
							// this.selectedBookList = [];
						} else {
							TMessage.error(res.msg);
						}
					});
				} else {
					this.connectSSEWithParams(userMessage.content, userMessage.imageList);
					// this.selectedImages = []; // 清空待发送图片
					this.isNewConversations = false;
					// this.keywork = '';
					// this.selectedBookList = [];
				}
				this.$nextTick(() => {
					this.isAutoScroll = true;
					this.scrollToBottom();
				});
			},

			// 通过 POST body 传递数据
			connectSSEWithParams(query, imageList) {
				this.$nextTick(() => {
					this.scrollToBottom();
				});
				const params = {
					query: query,
					user_id: String(this.uinfo.id),
					conversation_id: this.isConversations.id,
					book_list: '',
					kb_name: 'corporate_kb_collection',
					image_base64_list: imageList.map(img => img.base64)
				};

				//this.selectedBookList 中 children 合集 以 字符串拼接的形式 ，每个元素之间用逗号隔开
				if (this.selectedBookList.length > 0) {
					params.book_list = JSON.stringify(this.selectedBookList);
					//  params.book_list = this.selectedBookList;
				}

				let url = '';
				if (this.chatType == 'auto') {
					url = '/webZ_api/tgtai/chat/kb_chat_auto_post';
				} else if (this.chatType == 'rag' || this.chatType == 'book') {
					url = '/webZ_api/tgtai/chat/kb_chat_rag_post';
				} else {
					url = '/webZ_api/tgtai/chat/kb_chat_agent_post';
				}

				// console.log('url', url);

				let that = this;

				let ts = getTimestamp();
				let tempId = '';
				if (ts) {
					tempId = ts;
				} else {
					//生成一个10位随机数
					let tsNum = Math.floor(Math.random() * 10000000000);
					let timestamp = Date.now();
					tempId = String(timestamp) + '_' + String(tsNum); //临时id
					setTimestamp(tempId);
				}

				// EventSource 仅支持 GET，POST 改用 fetch 流式读取 SSE
				const abortController = new AbortController();

				// 兼容原有 eventSource.close() / onmessage / onerror 调用
				that.eventSource = {
					close: () => abortController.abort(),
					onmessage: null,
					onerror: null
				};

				fetch(url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${this.utoken}`,
						'Temp-id': tempId,
					},
					body: JSON.stringify(params),
					signal: abortController.signal
				})
					.then(async response => {
						// 检测非流式错误响应（如 {code: 401, msg: "可用次数为0!"}）
						const contentType = response.headers.get('content-type') || '';
						if (!contentType.includes('text/event-stream')) {
							let errorData = null;
							try {
								errorData = await response.json();
							} catch (e) {}
							if (errorData && errorData.msg) {
								TMessage.error(errorData.msg);
							} else if (errorData && errorData.code) {
								TMessage.error(`请求失败，错误码：${errorData.code}`);
							} else {
								TMessage.error('请求失败，请稍后重试');
							}
							// 清理消息状态
							that.eventSource.close();
							this.shouldDisableSubmit = false;
							const lastMessageIndex = this.messages.length - 1;
							if (this.messages[lastMessageIndex] && this.messages[lastMessageIndex].role === 'assistant') {
								this.messages[lastMessageIndex].isTyping = false;
								this.messages[lastMessageIndex].errorStr = errorData && errorData.msg ? errorData.msg : '请求失败';
								this.messages[lastMessageIndex].isThinking = false;
								this.messages[lastMessageIndex].hasThought = false;
							}
							return;
						}
						if (!response.ok) {
							throw new Error(`HTTP ${response.status}`);
						}
						const reader = response.body.getReader();
						const decoder = new TextDecoder('utf-8');
						let buffer = '';
						const pump = () => {
							return reader.read().then(({ done, value }) => {
								if (done) {
									// 流结束时处理残留的未分隔数据
									if (buffer && typeof that.eventSource.onmessage === 'function') {
										const dataStr = buffer
											.split(/\r?\n/)
											.filter(line => line.startsWith('data:'))
											.map(line => line.slice(5).trim())
											.join('\n');
										if (dataStr) {
											that.eventSource.onmessage({ data: dataStr });
										}
									}
									return;
								}
								buffer += decoder.decode(value, { stream: true });
								// SSE 事件以空行分隔，兼容 \n\n 与 \r\n\r\n 换行格式
								const parts = buffer.split(/\r?\n\r?\n/);
								buffer = parts.pop();
								parts.forEach(part => {
									const dataStr = part
										.split(/\r?\n/)
										.filter(line => line.startsWith('data:'))
										.map(line => line.slice(5).trim())
										.join('\n');
									if (dataStr && typeof that.eventSource.onmessage === 'function') {
										that.eventSource.onmessage({ data: dataStr });
									}
								});
								return pump();
							});
						};
						return pump();
					})
					.catch(error => {
						if (error.name === 'AbortError') return;
						console.error('SSE 错误:', error);
						if (typeof that.eventSource.onerror === 'function') {
							that.eventSource.onerror(error);
						}
					});

				this.getAiCount();

				that.eventSource.onmessage = event => {
					const data = JSON.parse(event.data);
					// console.log('sse data：', data)
					const lastMessageIndex = this.messages.length - 1;

					if (data.type && data.type == 'stage') {
						if (!this.messages[lastMessageIndex].thinking_process && !this.messages[lastMessageIndex].content) {
							// this.messages[lastMessageIndex].showStatusText += this.messages[lastMessageIndex].showStatusText + data.content;
							this.messages[lastMessageIndex].showStatusText += (this.messages[lastMessageIndex].showStatusText ? '<br/>' : '') + data.content;
						} else if (this.messages[lastMessageIndex].thinking_process && !this.messages[lastMessageIndex].content) {
							this.messages[lastMessageIndex].thinking_process += data.content;
						} else if (this.messages[lastMessageIndex].content) {
							this.messages[lastMessageIndex].content += data.content;
						}
					}

					//深度思考--过程
					if (data.type && data.type == 'thinking_process') {
						if (this.messages[lastMessageIndex] && this.messages[lastMessageIndex].role === 'assistant') {
							// 初始化thinking_process字段
							if (!this.messages[lastMessageIndex].thinking_process) {
								this.$set(this.messages[lastMessageIndex], 'thinking_process', '');
							}
							this.messages[lastMessageIndex].thinking_process += data.thinking_process || data.content || '';

							// 对累积的内容进行正则处理
							let thingProcessContent = EReg.aiFormatContentWithLinks(this.messages[lastMessageIndex].thinking_process);

							// 移除LaTeX公式中的换行符
							thingProcessContent = EReg.removeNewlinesInLatexFormulas(thingProcessContent);

							// 智能LaTeX公式渲染：检查是否有完整的公式结尾符号
							thingProcessContent = EReg.smartRenderLatexFormulas(thingProcessContent);

							// 将表格转换为换行符
							thingProcessContent = EReg.tableToNewLine(thingProcessContent);

							this.messages[lastMessageIndex].thinking_process = thingProcessContent;

							// 自动模式和深度思考模式下，首次收到思考过程时自动展开内联展示
							if ((this.chatType === 'auto' || this.chatType === 'agent') && !this.messages[lastMessageIndex].showAdditionalContent) {
								this.$set(this.messages[lastMessageIndex], 'showAdditionalContent', true);
							}
						}
					}

					//正式回答
					if (data.type && data.type == 'token') {
						if (this.messages[lastMessageIndex].role === 'assistant') {
							// 更新思考状态：正在接收内容，表示已思考完成
							this.messages[lastMessageIndex].isThinking = false;
							this.messages[lastMessageIndex].hasThought = true;

							// console.log('data.content', data.content);
							//判断是否有图片，提取图片URL并转换为占位符
							if (/<img\b/i.test(data.content)) {
								console.log('出现图片啦啦啦');
								// 提取图片URL
								const imgMatch = data.content.match(/<img[^>]*src=['"]([^'"]+)['"][^>]*>/i);
								if (imgMatch) {
									console.log('图片URL', imgMatch[1]);
									const imgUrl = imgMatch[1];
									// 如果图片出现在 markdown 表格中，走专用方法，避免块级 div 占位符破坏表格结构
									if (EReg.isInTableContext(this.messages[lastMessageIndex].content)) {
										data.content = EReg.handleTableImage(imgUrl);
									} else {
										data.content = EReg.handleImage(imgUrl);
									}
								}
							}
							this.messages[lastMessageIndex].content += data.content;
							this.messages[lastMessageIndex].isTyping = true;
							if (data.message_id) {
								this.messages[lastMessageIndex].id = data.message_id;
							}

							// 对累积的内容进行正则处理
							let sourceContent = EReg.aiFormatContentWithLinks(this.messages[lastMessageIndex].content);

							// 移除LaTeX公式中的换行符
							sourceContent = EReg.removeNewlinesInLatexFormulas(sourceContent);

							// 智能LaTeX公式渲染：检查是否有完整的公式结尾符号
							sourceContent = EReg.smartRenderLatexFormulas(sourceContent);

							// 将表格转换为换行符
							sourceContent = EReg.tableToNewLine(sourceContent);

							this.messages[lastMessageIndex].content = sourceContent;

							// 分割内容：以 "### 最终解答" 为分隔符，保留分割串在parts[1]中
							const fullContent = this.messages[lastMessageIndex].content;
							if (fullContent && fullContent.includes('### 最终解答：')) {
								const parts = fullContent.split('### 最终解答：');
								// parts[0] 是思考过程，parts[1] 是最终答案（包含 "### 最终解答" 这几个字）

								this.messages[lastMessageIndex].additionalContent = parts[0] || '';
								this.messages[lastMessageIndex].mainContent = parts[1] || '';
							} else {
								this.messages[lastMessageIndex].mainContent = fullContent;
								// console.log('777',this.messages[lastMessageIndex].mainContent)
								this.messages[lastMessageIndex].additionalContent = '';
							}

							// 开始新的打字效果
							// this.startTypingEffect(lastMessageIndex);
						}
					} else if (data.type && data.type == 'end') {
						// 结束打字状态
						const lastMessageIndex = this.messages.length - 1;
						if (data.timestamp) {
							this.messages[lastMessageIndex].createTime = data.timestamp.substring(0, 16) || '';
						}
						// 替换占位符为实际图片
						if (this.messages[lastMessageIndex].mainContent) {
							this.messages[lastMessageIndex].mainContent = EReg.showRealImage(this.messages[lastMessageIndex].mainContent);
						}
						if (this.messages[lastMessageIndex].additionalContent) {
							this.messages[lastMessageIndex].additionalContent = EReg.showRealImage(this.messages[lastMessageIndex].additionalContent);
						}

						if (this.messages[lastMessageIndex].role === 'assistant') {
							this.messages[lastMessageIndex].isTyping = false;
							// 确保思考状态正确更新
							this.messages[lastMessageIndex].isThinking = false;
							this.messages[lastMessageIndex].hasThought = true;
						}
						that.eventSource.close();
						this.shouldDisableSubmit = false;
					} else if (data.type && data.type == 'title') {
						this.isConversations.title = data.content;
						this.$router.replace({
							query: merge(this.$route.query, { id: this.isConversations.id, title: data.content })
						});
						renameConversation(this.isConversations.id, data.content).then(res => {
							// console.log('重命名会话啦啦啦');
						});
						// 同步更新左侧对话历史列表的标题
						['pinned', 'today', 'earlier'].forEach(group => {
							const list = (this.asideList && this.asideList[group]) || [];
							const item = list.find(v => String(v.id) === String(this.isConversations.id));
							if (item) {
								item.title = data.content;
							}
						});
					}
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				};

				that.eventSource.onerror = error => {
					that.eventSource.close();
					this.shouldDisableSubmit = false;
					this.showStatusText = '';
					if (this.messages.length > 0) {
						this.messages[this.messages.length - 1].showStatusText = '';
					}
					console.error('SSE 错误:', error);

					// 标记最后一条消息完成
					const lastMessageIndex = this.messages.length - 1;
					if (this.messages[lastMessageIndex].role === 'assistant') {
						this.messages[lastMessageIndex].isTyping = false;
						this.messages[lastMessageIndex].errorStr = '发生错误，请稍后再试';
						this.messages[lastMessageIndex].isThinking = false;
						this.messages[lastMessageIndex].hasThought = false; // 错误情况下标记为未思考
					}
				};
			},

			// 暂停生成
			handlePause() {
				// 调用API停止服务器端任务
				if (this.isConversations.id) {
					postStopTask({ conversation_id: this.isConversations.id })
						.then(res => {
							// console.log('停止任务成功:', res);
						})
						.catch(error => {
							// console.error('停止任务失败:', error);
						});
				}
				// 关闭EventSource连接
				if (this.eventSource) {
					this.eventSource.close();
					this.eventSource = null;
				}
				// 找到最后一条助手消息并标记为暂停
				const lastMessage = this.messages[this.messages.length - 1];
				if (lastMessage && lastMessage.role === 'assistant') {
					this.$set(lastMessage, 'isPause', true);
					this.$set(lastMessage, 'isTyping', false);
				}
				// 重置提交按钮状态
				this.shouldDisableSubmit = false;
				this.$nextTick(() => {
					this.isAutoScroll = true;
					this.scrollToBottom();
				});
				// 显示暂停提示
				this.$message.warning('已暂停生成，可点击“重新生成”按钮重新输出。');
				// bus.$emit('thinking_process_chose');
			},

			scrollToBottom() {
				// 只有在允许自动滚动时才执行
				if (!this.isAutoScroll) return;
				// 原有的滚动到底部逻辑
				const container = this.$refs.messageContainer;
				if (container && container.$el) {
					container.$el.scrollTop = container.$el.scrollHeight;
				} else if (container && container.scrollHeight !== undefined) {
					container.scrollTop = container.scrollHeight;
				}
				// 滚动到底部时锚点定位到最后一组
				if (this.conversationGroups.length > 0) {
					this.activeAnchorIndex = this.conversationGroups.length - 1;
				}
			},

			// 滚动到指定对话
			scrollToConversation(index) {
				const container = this.$refs.messageContainer;
				if (!container) return;
				const containerEl = container.$el || container;
				const messageItems = containerEl.querySelectorAll('.message-item');
				const targetItemIndex = index * 2;
				const targetElement = messageItems[targetItemIndex];
				if (targetElement) {
					const containerRect = containerEl.getBoundingClientRect();
					const targetRect = targetElement.getBoundingClientRect();
					// 目标滚动位置 = 当前滚动量 + 元素相对容器顶部距离 - 82px（标题栏高度）
					const targetScrollTop = containerEl.scrollTop + targetRect.top - containerRect.top - 82;
					containerEl.scrollTo({
						top: Math.max(0, targetScrollTop),
						behavior: 'smooth'
					});
				}
			},

			// 更新活跃锚点（根据滚动位置）
			updateActiveAnchor() {
				const container = this.$refs.messageContainer;
				if (!container) return;
				const containerEl = container.$el || container;
				const messageItems = containerEl.querySelectorAll('.message-item');
				if (!messageItems.length || !this.conversationGroups.length) {
					this.activeAnchorIndex = -1;
					return;
				}
				const containerRect = containerEl.getBoundingClientRect();
				// 标题栏固定高度 82px，可视区域从 containerRect.top + 82 开始
				const TITLE_HEIGHT = 82;
				const visibleTop = containerRect.top + TITLE_HEIGHT;
				const visibleHeight = containerRect.height - TITLE_HEIGHT;
				const referenceY = visibleTop + Math.max(0, visibleHeight) * 0.3;
				let activeIndex = this.conversationGroups.length - 1;
				let closestDistance = Infinity;
				for (let i = 0; i < messageItems.length; i += 2) {
					const rect = messageItems[i].getBoundingClientRect();
					if (rect.top <= referenceY + 50) {
						const distance = referenceY - rect.top;
						if (distance >= 0 && distance < closestDistance) {
							closestDistance = distance;
							activeIndex = Math.floor(i / 2);
						}
					}
				}
				this.activeAnchorIndex = activeIndex;
			},

			changeChatType(chatType) {
				// 如果切换模式且已选择书单，清除已选书单
				if (chatType !== 'book' && this.selectedBookList.length > 0) {
					this.selectedBookList = [];
				}
				// 书单模式需要登录
				if (chatType === 'book' && !this.uisLogin) {
					this.$message.warning('请先登录，体验更多功能');
					return;
				}
				// 书单模式：先打开书单选择弹窗
				if (chatType === 'book') {
					this.chatType = chatType;
					this.handleSelectBook();
					return;
				}
				// 未登录状态：检查对应模式次数
				if (!this.uisLogin) {
					if (chatType === 'auto' && this.aiCount.autoPost === 0) {
						this.$message.warning('没有继续提问机会，请先登录');
						return;
					}
					if (chatType === 'rag' && this.aiCount.ragPost === 0) {
						this.$message.warning('没有继续提问机会，请先登录');
						return;
					}
					if (chatType === 'agent' && this.aiCount.agentPost === 0) {
						this.$message.warning('没有继续提问机会，请先登录');
						return;
					}
				} else {
					// 已登录状态
					if (this.uisVIP) {
						// VIP会员：不校验次数
						this.chatType = chatType;
						return;
					} 
				}
				this.chatType = chatType;
			},

			handleClearConversation() {
				TMessageBox.confirm('确定要删除当前对话吗？删除之后不可恢复!')
					.then(() => {
						clearConversation(this.isConversations.id).then(res => {
							this.messages = [];
							this.selectedBookList = []; // 清空选中的书单
							this.chatType = 'auto';
							this.keywork = ''; // 清空输入框
							//关闭
							if (this.eventSource) {
								this.eventSource.close();
							}
						});
					})
					.catch(() => {});
			}
		},

		// 在组件销毁前清理所有定时器
		beforeDestroy() {
			// 清理滚动事件监听
			if (this.$refs.messageContainer) {
				this.$refs.messageContainer.removeEventListener('scroll', this.handleScroll);
			}
			// 关闭SSE连接
			if (this.eventSource) {
				this.eventSource.close();
			}
			bus.$off('message');
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .el-dropdown-menu__item {
		display: flex;
		align-items: center;
	}

	.chat-submit-main /deep/ .el-textarea__inner {
		height: 66px !important;
	}

	.main-container {
		background: #f8fafc;
		padding-bottom: 0;
		padding-right: 10px;
		position: relative;
		height: calc(100vh - 72px);
		font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
	}

	.main-container-chat {
		height: 100%;
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.main-container-chat-center {
		justify-content: center;
	}

	.chat-content {
		width: 100%;
		margin: 0 auto;
		flex: 1;
		min-height: 0;
		overflow: auto;
		position: relative;
		overflow-x: hidden;

		scrollbar-width: thin; // Firefox 滚动条样式

		&::-webkit-scrollbar {
			height: 6px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 3px;
		}

		&::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 3px;

			&:hover {
				background: #a8a8a8;
			}
		}
	}

	.chat-content-title {
		text-align: center;
		padding: 20px 0;
		font-weight: 700;
		font-size: 26px;
		width: calc(100% - 600px);
		position: fixed;
		background-color: #f8fafc;
		top: 70px; /* pt-16 = 64px */
		z-index: 1;
	}

	.chat-content-loading {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
		color: #94a3b8;
		font-size: 15px;

		.el-icon-loading {
			font-size: 32px;
		}
	}

	.chat-content-content-title {
		max-width: 70rem;
		// width: 100%;
		overflow: hidden;
		margin: 80px auto 0;
		padding: 0 16px;
	}
</style>

<style>
	.markdown-body table {
		border-collapse: collapse;
		border-spacing: 0;
		display: block;
		width: 100%;
		overflow: auto;
		word-break: normal;
		word-break: keep-all;
	}

	.markdown-body table th {
		font-weight: 700;
	}

	.markdown-body strong {
		font-size: 14px;
	}

	.markdown-body h2 {
		line-height: 23px;
	}

	.markdown-body table td,
	.markdown-body table th {
		padding: 6px 13px;
		border: 1px solid #ddd;
		word-break: break-word;
	}

	.markdown-body table tr {
		background-color: #fff;
		border-top: 1px solid #ccc;
	}

	.markdown-body table tr:nth-child(2n) {
		background-color: #f8f8f8;
	}
	.icon-paperclip {
		cursor: pointer;
		color: rgba(0, 0, 0, 0.86);
		margin-right: 22px;
		font-size: 20px;
	}

	.popover-mode {
		padding: 18px !important;
	}

	.popover-mode-content {
		font-size: 13px;
		line-height: 26px;
	}

	.popover-mode-content .popover-mode-title {
		font-size: 14px;
		font-weight: 600;
		color: #2c2c2e;
	}

	.popover-mode-content p {
		margin: 0;
		position: relative;
		margin-left: 8px;
	}

	.popover-mode-content-book .tip:before {
		content: '';
		border-radius: 50%;
		position: absolute;
		left: -12px;
		top: 11px;
		width: 5px;
		height: 5px;
		background-color: #1456f0;
	}

	.popover-paperclip {
		padding: 0 !important;
	}

	.popover-paperclip ul {
		list-style: none;
		padding: 10px 0;
		margin: 0;
	}

	.popover-paperclip li {
		list-style: none;
		/* line-height: 32px; */
		padding: 0 20px;
		margin: 0;
		font-size: 13px;
		color: #606266;
		cursor: pointer;
		outline: none;
	}

	.popover-paperclip li:hover {
		background-color: #ecf5ff;
		color: #66b1ff;
	}

	.chat-submit-main .el-textarea .el-input__count {
		bottom: 48px !important;
		right: 22px !important;
		color: #94a3b8;
		background: transparent;
	}

	/* 锚点面板过渡动画 */
	.anchor-panel-fade-enter-active,
	.anchor-panel-fade-leave-active {
		transition: opacity 0.2s ease, transform 0.2s ease;
	}

	.anchor-panel-fade-enter,
	.anchor-panel-fade-leave-to {
		opacity: 0;
		transform: translateX(12px);
	}
</style>
